import { Text, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

import { colors } from '../../colors';
import { styles } from './ErrorState.styles';

export type ErrorStateProps = {
  title: string;
  message: string;
  testID?: string;
};

/** Danger/warning triangle with exclamation (22×19), aligned to Figma. */
function DangerIcon() {
  return (
    <View style={styles.iconContainer}>
      <Svg width={22} height={19} viewBox="0 0 22 19" fill="none">
        <Path
          d="M0 19H22L11 0L0 19ZM3.47 17L11 3.99L18.53 17H3.47ZM10 14H12V16H10V14ZM10 8H12V12H10V8Z"
          fill={colors.errorBannerBorder}
        />
      </Svg>
    </View>
  );
}

/**
 * Reusable error banner (e.g. layout unavailable). Title and message are configurable.
 * Matches Figma: Layout unavailable — node 2496:39621.
 */
export default function ErrorState({ title, message, testID = 'error-state' }: ErrorStateProps) {
  return (
    <View style={styles.container} testID={testID}>
      <DangerIcon />
      <View style={styles.textColumn}>
        <Text style={styles.title} testID={`${testID}-title`}>
          {title}
        </Text>
        <Text style={styles.message} testID={`${testID}-message`}>
          {message}
        </Text>
      </View>
    </View>
  );
}
